import React, { useEffect, useState } from "react";
import { Route, HashRouter } from "react-router-dom";
import { AADProvider, BuildNumberContext } from "psg-react-components";

import { NewTemplateDialogContext, SearchContext, DarkThemeContext, SnContext } from "./utils/context";
import Navbar from "./components/Navbar";
import TemplateCreation from "./components/creation/TemplateCreation";
import TemplateGrid from "./components/creation/TemplateGrid";
import { FocusStyleManager } from "@blueprintjs/core";
import TemplateRunsGrid from "./components/runs/TemplateRunsGrid";
import { useLocalBoolState } from "./hooks/useLocalBoolState";
import CustomLoader from "./components/CustomLoader";

FocusStyleManager.onlyShowFocusOnTabs();
type Config = {
    CLIENT_ID: string;
    TENANT_ID: string;
    REDIRECT_URI: string;
    SCOPE: string;
    GRAPH_ENDPOINT: string;
    SN_CONTEXT: "darms" | "uarms" | "amp";
};
const { CLIENT_ID, TENANT_ID, REDIRECT_URI, SCOPE, GRAPH_ENDPOINT, SN_CONTEXT } = {
    ...((window as any).config as Config)
};

export default function App() {
    const [buildNumber, setBuildNumber] = useState("");
    const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [dark, setDark] = useLocalBoolState("dark-mode", true);

    useEffect(() => {
        if (dark) {
            document.body.classList.add("bp3-dark");
        } else {
            document.body.classList.remove("bp3-dark");
        }
    }, [dark]);
    useEffect(() => {
        async function getBuildNumber() {
            try {
                const response = await fetch("/buildInfo.json");
                const buildInfo = await response.json();

                if (buildInfo?.BuildNumber) {
                    setBuildNumber(buildInfo.BuildNumber);
                    console.log(`Build Number: ${buildInfo.BuildNumber}`);
                }
            } catch (error) {
                console.error("buildInfo.json error", error);
            }
        }

        getBuildNumber();
    }, []);

    return (
        <div id="app" className={dark ? "bp3-dark" : ""}>
            <AADProvider
                clientId={CLIENT_ID}
                redirectUri={REDIRECT_URI}
                scopes={[SCOPE]}
                tenantId={TENANT_ID}
                graphqlEndpoint={GRAPH_ENDPOINT}
                loadingView={<CustomLoader />}
                enableSubscriptions
            >
                <DarkThemeContext.Provider value={dark}>
                    <BuildNumberContext.Provider value={buildNumber}>
                        <SnContext.Provider value={SN_CONTEXT}>
                            <NewTemplateDialogContext.Provider value={[templateDialogOpen, setTemplateDialogOpen]}>
                                <SearchContext.Provider value={[search, setSearch]}>
                                    <HashRouter>
                                        <Navbar toggleTheme={() => setDark(d => !d)} />
                                        <TemplateCreation />
                                        <Route exact path="/" component={TemplateGrid} />
                                        <Route path="/runs" component={TemplateRunsGrid} />
                                    </HashRouter>
                                </SearchContext.Provider>
                            </NewTemplateDialogContext.Provider>
                        </SnContext.Provider>
                    </BuildNumberContext.Provider>
                </DarkThemeContext.Provider>
            </AADProvider>
        </div>
    );
}
